/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-restricted-syntax */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {onlyToast} from 'hiya-common/src/App/CustomToaster'
import {ListItemType} from 'hiya-common/src/reducers/commonTypes'
import {http} from 'hiya-common/src/utils/axios'
import {HostMaps} from 'hiya-common/src/utils/host/AutoHost'

export enum ModalTypeEnum {
  openBox = 1,
  getReward,
  rank20,
}
export const urlHead = `${HostMaps.prod.img01}/img/png/id/58137315053`
export const urlCoin = `${HostMaps.prod.img01}/img/png/id/58137364407`
// 打怪兽活动获取奖励 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=35761477
export const beat_monster_get_reward = createAsyncThunk(
  'beat_monster_get_reward',
  async (arg: {stage_id: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          'list' | 'reward_info' | 'reward_type' | 'err_msg'
        >
      >
    >(
      '/live/activity/beat_monster_get_reward',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    const {err_msg = ''} = resp.data.data
    if (err_msg) {
      onlyToast(err_msg)
    }
    return resp.data.data
  }
)
export enum statusEnum {
  notStart = 0,
  open,
  opened,
}

interface InitialStateType {
  // 奖励获取
  list?: Array<ListItemType>
  reward_info?: {
    is_coin: boolean
    url: string
    desc: string
    num: number
  }
  reward_type?: number
  err_msg?: string
}

const initialState: InitialStateType = {}

export const HitAnimalsModalSlice = createSlice({
  name: 'HitAnimalsModal',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // 领取页面相关
    builder.addCase(beat_monster_get_reward.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default HitAnimalsModalSlice.reducer
export const HitAnimalsModalActions = HitAnimalsModalSlice.actions
